import { render, staticRenderFns } from "./HighLightedStudies.vue?vue&type=template&id=300df3cc&"
import script from "./HighLightedStudies.vue?vue&type=script&lang=js&"
export * from "./HighLightedStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports